import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PartnerContact } from '../models/partner-contact';
import { PartnerContactType } from '../models/partner-contact-type';

import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class PartnerContactService {

    constructor(private httpService: JsonHttpService) { }

    getContactTypes(): Promise<PartnerContactType[]> {
        return this.httpService.get('/api/partners/contacts/get-contact-types').toPromise();
    };

    getContactsForPartner(partnerId: number): Promise<PartnerContact[]> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.get('/api/partners/contacts/get-contacts-for-partner', options).toPromise();
    };

    saveContact(contact: PartnerContact): Promise<PartnerContact> {
        return this.httpService.post('/api/partners/contacts/save-contact', contact).toPromise();
    }

    deleteContact(contactId: number): Promise<boolean> {
        const options = { params: new HttpParams().set('contactId', `${contactId}`) };
        return this.httpService.post('/api/partners/contacts/delete-contact', null, options).toPromise();
    }

    /* Contact types */

    deleteContactType(contactTypeId: number): Promise<boolean> {
        const options = { params: new HttpParams().set('contactTypeId', `${contactTypeId}`) };
        return this.httpService.post('/api/partners/contacts/delete-contact-type', null, options, false).toPromise();
    }

    saveContactType(contact: PartnerContactType): Promise<PartnerContactType> {
        return this.httpService.post('/api/partners/contacts/save-contact-type', contact).toPromise();
    }
}
